import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import { useLocation } from 'react-router'
import MakeHeader from '../ReusableComponents/Header/MakeHeader'
import '../Make/Make.css'

const BACKEND_URL = process.env.REACT_APP_API_BASE

// Map program id → admin route
const PROGRAM_ROUTE_MAP = {
    toki: '/makeAdmin',
    poki: '/makeAdmin',
}

const AdminHome = () => {
    const history = useHistory()
    const location = useLocation()
    const [programs, setPrograms] = useState([])
    const [loading, setLoading] = useState(true)
    const [user, setUser] = useState(null)
    const [authLoading, setAuthLoading] = useState(true)
    const [loginError, setLoginError] = useState('')
    const [isLoggingIn, setIsLoggingIn] = useState(false)

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const errorParam = params.get('error')

        if (errorParam) {
            if (errorParam === 'unauthorized') {
                setLoginError(
                    'Login authentication failed: Account not authorized.'
                )
            } else {
                setLoginError('Login authentication failed. Please try again.')
            }
            history.replace('/admin')
        }

        fetch(`${BACKEND_URL}/me`, {
            credentials: 'include',
        })
            .then((res) => res.json())
            .then((data) => {
                setUser(data)
                setAuthLoading(false)
            })
            .catch(() => {
                setUser(null)
                setAuthLoading(false)
            })
    }, [location.search, history])

    useEffect(() => {
        if (!user) return
        fetch(`${BACKEND_URL}/api/programs`, { credentials: 'include' })
            .then((res) => res.json())
            .then((data) => {
                setPrograms(data)
                setLoading(false)
            })
            .catch((err) => {
                console.error('Failed to load programs:', err)
                setLoading(false)
            })
    }, [user])

    const handleLoginClick = () => {
        setIsLoggingIn(true)
        setLoginError('')
        window.location.href = `${BACKEND_URL}/auth/github?state=/admin`
    }

    const handleSelect = (id) => {
        // Store the canonical, capitalized device name (e.g. 'Poki', 'Toki') —
        // the SAME form KitSelection stores. The live assembly (AssemblyTwo) and
        // assemblyAccessoriesApi compare connectedDevice against capitalized names
        // ('Poki', ['Toki','Poki'], ...) to pick the correct board image. Storing a
        // lowercased 'poki' here fails those checks and falls back to the PeeCee
        // board image in preview mode. Downstream admin code lowercases where it
        // needs to (API calls) and resolveBoardKey uppercases, so this is safe.
        const canonicalDevice = id.charAt(0).toUpperCase() + id.slice(1).toLowerCase()
        sessionStorage.setItem('connectedDevice', canonicalDevice)
        sessionStorage.setItem('allowedDevice', canonicalDevice)
        sessionStorage.setItem('deviceVersion', '1')
        const route = PROGRAM_ROUTE_MAP[id] || `/${id}EngineAdmin`
        history.push(route)
    }

    if (authLoading) {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    fontSize: '1rem',
                    color: '#666',
                }}
            >
                Checking authorization...
            </div>
        )
    }

    if (!user) {
        return (
            <div className="Main_Select">
                <div className="Select_Headers">
                    <MakeHeader
                        title="Admin Access"
                        titlePosition="left"
                        isGoBack={true}
                        goBack={() => history.push('/kitSelection')}
                        showAccountSetting={false}
                        showBluetoothBtn={false}
                    />
                </div>

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: '70vh',
                    }}
                >
                    <div
                        style={{
                            textAlign: 'center',
                            maxWidth: '380px',
                            width: '100%',
                            backgroundColor: 'white',
                            padding: '40px 30px',
                            borderRadius: '16px',
                            boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
                            border: '1px solid #eaeaea',
                        }}
                    >
                        <div style={{ marginBottom: '20px' }}>
                            <svg
                                height="48"
                                viewBox="0 0 16 16"
                                version="1.1"
                                width="48"
                                aria-hidden="true"
                            >
                                <path
                                    fill="#2f2e65"
                                    fillRule="evenodd"
                                    d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"
                                ></path>
                            </svg>
                        </div>
                        <div
                            style={{
                                fontSize: '20px',
                                color: '#2f2e65',
                                marginBottom: '10px',
                                fontFamily: 'Halcyon_SemiBold, sans-serif',
                            }}
                        >
                            Admin Portal
                        </div>

                        <div
                            style={{
                                fontSize: '14px',
                                color: '#666',
                                marginBottom: '20px',
                                lineHeight: '1.5',
                            }}
                        >
                            Sign in with an authorized GitHub account to access
                            admin pages.
                        </div>

                        {loginError && (
                            <div
                                style={{
                                    marginBottom: '20px',
                                    padding: '12px',
                                    backgroundColor: '#fff2f2',
                                    color: '#d32f2f',
                                    borderRadius: '6px',
                                    fontSize: '13px',
                                    border: '1px solid #ffcdd2',
                                    textAlign: 'center',
                                    fontWeight: '500',
                                }}
                            >
                                {loginError}
                            </div>
                        )}

                        <button
                            onClick={handleLoginClick}
                            disabled={isLoggingIn}
                            style={{
                                width: '100%',
                                padding: '12px 18px',
                                backgroundColor: isLoggingIn
                                    ? '#5c5b8b'
                                    : '#2f2e65',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                fontSize: '15px',
                                fontWeight: 'bold',
                                cursor: isLoggingIn ? 'not-allowed' : 'pointer',
                            }}
                        >
                            {isLoggingIn
                                ? 'Connecting to GitHub...'
                                : loginError
                                  ? 'Try GitHub Login Again'
                                  : 'Login with GitHub'}
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="Main_Select">
            <div className="Select_Headers">
                <MakeHeader
                    title="Admin Access"
                    titlePosition="left"
                    isGoBack={true}
                    goBack={() => history.push('/kitSelection')}
                    showAccountSetting={false}
                    showBluetoothBtn={false}
                />
            </div>

            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '70vh',
                    gap: '32px',
                }}
            >
                <h2
                    style={{
                        fontSize: '1.4rem',
                        fontWeight: 600,
                        color: '#333',
                        margin: 0,
                    }}
                >
                    Choose Device
                </h2>

                {loading ? (
                    <p style={{ color: '#888', fontSize: '1rem' }}>
                        Loading...
                    </p>
                ) : (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '30px',
                        }}
                    >
                        {/* Programs Collection Grid */}
                        <div
                            style={{
                                display: 'flex',
                                gap: '20px',
                                flexWrap: 'wrap',
                                justifyContent: 'center',
                            }}
                        >
                            {programs.map((prog) => (
                                <button
                                    key={prog.id}
                                    onClick={() => handleSelect(prog.id)}
                                    style={{
                                        padding: '18px 40px',
                                        fontSize: '1.1rem',
                                        fontWeight: 600,
                                        borderRadius: '12px',
                                        border: '2px solid #ddd',
                                        background: '#fff',
                                        color: '#333',
                                        cursor: 'pointer',
                                        minWidth: '160px',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                        transition: 'border-color 0.15s, box-shadow 0.15s',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.borderColor = '#555'
                                        e.currentTarget.style.boxShadow = '0 4px 14px rgba(0,0,0,0.14)'
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.borderColor = '#ddd'
                                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)'
                                    }}
                                >
                                    {prog.title}
                                </button>
                            ))}
                        </div>

                        {/* Divider Line */}
                        <div style={{ width: '100%', height: '1px', background: '#e2e8f0', maxWidth: '400px' }} />

                        {/* Dedicated Expansion Kits Link Option */}
                        <button
                            onClick={() => history.push('/expansionKitAdmin')}
                            style={{
                                padding: '16px 36px',
                                fontSize: '1rem',
                                fontWeight: 700,
                                borderRadius: '12px',
                                border: 'none',
                                background: '#475569',
                                color: '#fff',
                                cursor: 'pointer',
                                minWidth: '220px',
                                boxShadow: '0 4px 12px rgba(71, 85, 105, 0.25)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '10px',
                                transition: 'background-color 0.15s, transform 0.1s'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#334155'
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = '#475569'
                            }}
                        >
                            <span>⚙️ Manage Expansion Kits</span>
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}

export default AdminHome
